module.exports = "nz-content {\n  padding: 0 !important; }\n"